<template>
  <v-dialog :value="open" max-width="50vw" @input="$emit('dialog:close')">
    <v-card>
      <v-card-title class="headline">
        <div>
          <v-icon medium class="mr-2">info</v-icon>
          {{$t('message.redirect.title')}}
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table :items="items" hide-headers hide-actions :total-items="-1">
          <template #items="{ item }">
            <template v-if="item.redirectCode">
              <td>{{$t('message.redirect.redirectCode')}}</td>
              <td>{{$t(`message.redirect.code.${item.redirectCode}`)}}</td>
            </template>

            <template v-if="item.url">
              <td v-html="$t('message.redirect.url')"></td>
              <td>
                <a :href="item.url" target="_blank" v-html="item.url"></a>
              </td>
            </template>

            <template v-if="item.entity">
              <td v-html="$t('message.redirect.destination')"></td>
              <td>
                {{$t(`message.entity.type.${item.entity.type || entityType}`) | capitalize }}
              </td>
            </template>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat
          @click.native="$emit('dialog:close')"
        >{{ $t('message.common.close') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  props: {
    value: Object,
    open: Boolean,
  },
  computed: {
    items() {
      return Object.entries(this.value).map(([k, v]) => ({ [k]: v }));
    },
    // para el tipo de la entidad 'site'
    entityType() {
      return this.value.type;
    },
  },
};
</script>
